module.exports = __webpack_public_path__ + "content/80685790d982275b4b1ec1a53bbd13df.svg";